<div
  class="d-flex flex-column overflow-auto col-md-12 bkg-color--grey-1000"
  ui-view="project-trends"
></div>
